import { useMemo } from 'react';

import { ViolationAct } from '@/features/violationActs/types';
import { ViolationActInfoFormDefaultValues } from '@/forms/ViolationActInfoForm';

import { extractDataByPath } from './extractDataByPath';

type ActInformationStepEditData = ViolationActInfoFormDefaultValues & {
  documents: ViolationAct['documents'];
};

export const useActInformationStepEditData = (
  violationAct?: ViolationAct,
): ActInformationStepEditData | undefined =>
  useMemo(() => {
    if (!violationAct) {
      return undefined;
    }
    const getByPath = extractDataByPath<ViolationAct>(violationAct);

    return {
      id: getByPath('id'),
      date: getByPath('date'),
      startTime: getByPath('date'),
      number: getByPath('number'),
      violationTypeId: getByPath('violationType.id'),
      violationMeasureId: getByPath('violationMeasure.id'),
      resultId: getByPath('result.id'),
      violationDecisionId: getByPath('violationDecision.id'),
      performerId: getByPath('performer.id'),
      comment: getByPath('comment'),
      deadline: getByPath('deadline'),
      executionDate: getByPath('executionDate'),
      documents: getByPath('documents') as unknown as ViolationAct['documents'],
    };
  }, [violationAct]);
